import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
  Typography,
  Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PushPinIcon from "@mui/icons-material/PushPin";
import Notify from "../../../Notify";
import { getData, putData } from "../../../../services/library";
import CompletarDatosFacturacion from "./CompletarDatosFacturacion";
import FacturarPedido from "./FacturarPedido";
import FacturarDetalle from "./FacturarDetalle";

function ModalFacturar(props) {
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [datosformulario, setDatosformulario] = useState(props.dataPedido);
  const [disBtn, setDisBtn] = useState(false);
  const handleClose = () => {
    props.onClose();
  };

  return (
    <div>
      {notificacion && notificacion.open ? (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={() => {
            props.onClose(false);
          }}
          severity={notificacion.severity}
        />
      ) : null}
      <Dialog
        fullWidth
        open={props.open}
        onClose={() => props.onClose(false)}
        maxWidth={"lg"}
        PaperProps={{
          sx: {
            maxHeight: "90vh",
            minHeight: "70vh",
          },
        }}
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography variant="h6" align="center" color="#ffffff">
              Facturar Pedido N° {datosformulario.id}
            </Typography>
          </DialogTitle>
        </Box>
        <DialogContent sx={{ p: 0 }}>
          {props.dataPedido.estado === 310 ? (
            <CompletarDatosFacturacion
              datosformulario={datosformulario}
              onClose={handleClose}
            />
          ) : (
            <FacturarDetalle
              datosformulario={datosformulario}
              onClose={handleClose}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default ModalFacturar;
